
<div class="card h-100">
  <template v-if="state.repCode && !state.repCode._multi">
    <template v-if="state.repCode.code === 'UNASSIGNED' || state.repCode.code === null">
      <div class="card-header px-3 py-2">
        <i class="fas fa-tag mr-2"></i>
        <span class="font-weight-bold">Unassigned — {{nav.item}}</span>
      </div>
    </template>
    <template v-else>
      <div class="card-header px-3 py-2">
        <i class="fas fa-tag mr-2"></i>
        <span class="font-weight-bold"
              v-text="(state.repCode.label || state.repCode.code) + ' - ' + nav.item"></span>
      </div>
    </template>
    <div class="card-body pt-3">
      <ul class="nav nav-tabs">
        <li v-for="(item, i) in nav.items" :key="i" class="nav-item">
          <a class="nav-link"
             :class="nav.class(`active`, item)"
             v-on:click="nav.click(item)">
            <i :class="nav.class(`icon`, item)" class="mr-1"></i>
            <span v-text="item"></span>
          </a>
        </li>
      </ul>
      <template v-if="nav.item">
        <div class="component">
          <component :is="nav.component" :list="nav.list"></component>
        </div>
      </template>
    </div>
  </template>
  <template v-else-if="state.repCode && state.repCode._multi">
    <div class="card-header px-3 py-2">
      <i class="fas fa-tags mr-2"></i>
      <span class="font-weight-bold">{{state.repCode.codes.length}} RepCodes selected — {{nav.item}}</span>
    </div>
    <div class="card-body pt-3">
      <ul class="nav nav-tabs">
        <li v-for="(item, i) in nav.items" :key="i" class="nav-item">
          <a class="nav-link"
             :class="nav.class(`active`, item)"
             v-on:click="nav.click(item)">
            <i :class="nav.class(`icon`, item)" class="mr-1"></i>
            <span v-text="item"></span>
          </a>
        </li>
      </ul>
      <template v-if="nav.item">
        <div class="component">
          <component :is="nav.component" :list="nav.list"></component>
        </div>
      </template>
    </div>
  </template>
  <template v-else>
    <div class="card-header px-3 py-2">
      <i class="fas fa-tag mr-2"></i>
      <span class="font-weight-bold">RepCode</span>
    </div>
    <div class="card-body pt-3">
      <h5 class="text-center my-5">No RepCode selected</h5>
    </div>
  </template>
</div>
